import type { FC } from "react";

import type { BuilderBlock } from "@builder.io/sdk-react";

import { FlavourCarousel as FlavourCarouselUI } from "@jti/ui/components/FlavourCarousel";
import type { FlavourProperties } from "@jti/ui/components/FlavourCarousel/components/FlavourRating/FlavourRating";

import type { flavourCarouselInputs } from "./FlavourCarousel.builder";

type FlavourCarouselBuilderProps = BuilderComponentProps<typeof flavourCarouselInputs> & {
  builderBlock: BuilderBlock;
};

export const FlavourCarousel: FC<FlavourCarouselBuilderProps> = ({
  backgroundImage,
  title,
  description,
  redirectLink,
  isInversed,
  isThumbnailsCarouselHidden,
  builderBlock,
}) => {
  const flavourCards = (builderBlock?.children ?? []).filter(Boolean).map((child) => {
    const options = child.component?.options;
    return {
      ...options,
      flavours: options?.flavours?.map((flavour: FlavourProperties) => {
        return {
          ...flavour,
          rating: Number(flavour.rating) as FlavourProperties["rating"],
        };
      }),
    };
  });

  return (
    <FlavourCarouselUI
      backgroundImage={backgroundImage}
      description={description}
      title={title}
      redirectLink={redirectLink}
      flavourCards={flavourCards}
      isThumbnailsCarouselHidden={isThumbnailsCarouselHidden}
      isInversed={isInversed}
    />
  );
};
